// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".video-banner[data-v-06748ba2]{position:relative;display:block;cursor:pointer}.video-banner>img[data-v-06748ba2]{display:block;width:100%}.video-banner-close[data-v-06748ba2]{position:absolute;right:5px;top:5px}", ""]);
// Exports
module.exports = exports;
